<template>
    <form-select-group :options="localeOptions" :selected="currentLocale" @input="setLocale"></form-select-group>
</template>

<script>
import {FormSelectGroup} from "atom";

import {store} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions, mapGetters} = createNamespacedHelpers("arcman");
/**
 *
 * @vue-prop {String} message - greetings message
 */
export default {
    name: "locale-selector",
    components: {FormSelectGroup},
    computed: {
        ...mapGetters(["currentLocale"]),
        localeOptions() {
            return this.$settings.languages.supported.map(locale => {
                return {
                    text: locale,
                    value: locale,
                };
            });
        },
    },
    methods: {
        ...mapActions({
            setLanguage: "SET_LANGUAGE",
        }),
        setLocale(locale) {
            this.setLanguage({language: locale});
        },
    },
    mounted() {
        this.setLocale(localStorage.getItem("ARCMAN.locale") || this.localeOptions[0].value);
    },
};
</script>
